import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { toastError, countryActionId, cityActionId, industryActionId, stateActionId } from '../../utils/constants'
import { fill_action } from '../../actions/fillCombo_action'
import Pagination from "../../utils/pagination";
import Header from '../../common_components/Header';
import { get_userList_action, share_credential_action } from '../../actions/adminAction/users_action';

class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
    }
    render() {
        const { isLoading,  } = this.state
        // const recordsPerPage = 10;
        // const indexOfLastRecord = currentPage * recordsPerPage;
        // const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // const currentRecords = usersList.slice(
        //     indexOfFirstRecord,
        //     indexOfLastRecord
        // );
        // const nPages = Math.ceil(usersList.length / recordsPerPage);
        return (
            <>
                {isLoading ? (
                    // <Loader></Loader>
                    <></>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />
                <ToastContainer />
            </>)
    }
}

export default withRouter(connect(null, { fill_action,  })(Dashboard));
